import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/cancel.svg'
import _imports_1 from '@/assets/leftArrowFilled.svg'
import _imports_2 from '@/assets/rightArrowFilled.svg'
import _imports_3 from '@/assets/pdfs.svg'
import _imports_4 from '@/assets/arrowRight.svg'
import _imports_5 from '@/assets/sortBy.svg'
import _imports_6 from '@/assets/InfoDefault.svg'
import _imports_7 from '@/assets/commentDefault.svg'
import _imports_8 from '@/assets/flowIcon.svg'
import _imports_9 from '@/assets/controlDefault.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "flex justify-between items-center mt-2" }
const _hoisted_5 = { class: "flex items-center gap-5" }
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex rounded w-32 items-center justify-center py-1 regular text-xs" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex rounded w-32 items-center justify-center py-1 regular text-xs" }
const _hoisted_11 = { class: "text-xs" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = {
  key: 0,
  class: "flex gap-3"
}
const _hoisted_14 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_15 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_16 = { class: "formcontainer flex flex-col" }
const _hoisted_17 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_18 = { class: "w-full" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "formcontainer flex flex-col" }
const _hoisted_21 = { class: "buttonposition flex justify-center items-center mt-4 mx-0" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "w-full" }
const _hoisted_25 = { class: "centerContainer flex flex-row justify-between space-x-2 mt-5" }
const _hoisted_26 = {
  key: 0,
  class: "group-buttons mt-2.5"
}
const _hoisted_27 = {
  key: 1,
  class: "group-buttons mt-2.5"
}
const _hoisted_28 = {
  key: 0,
  class: "pb-1 adjust"
}
const _hoisted_29 = {
  key: 1,
  class: "mx-4 flex flex-row borderBottom justify-between cursor-pointer tab-container",
  ref: "tabContainer"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "progressbarB rounded-sm ml-5 mr-5 relative h-1 mx-2.5"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_34 = ["data"]
const _hoisted_35 = {
  key: 1,
  class: "p-2"
}
const _hoisted_36 = { class: "approvalHeader justify-between flex items-center" }
const _hoisted_37 = { class: "flex justify-center w-full" }
const _hoisted_38 = {
  key: 1,
  class: "mx-2"
}
const _hoisted_39 = { class: "card previousDocStyle w-full mt-2 px-4 heightOfInnerdiv overflow-scroll no-scrollbar" }
const _hoisted_40 = {
  key: 0,
  class: "absolute top-2/4 alignmentDocument"
}
const _hoisted_41 = {
  key: 1,
  class: "flex mt-4 gap-4 flex-wrap cursor-pointer"
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "text-xs ml-1" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "text-xs ml-1" }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { class: "p-2" }
const _hoisted_50 = { class: "card heightOfInnerdiv overflow-scroll no-scrollbar" }
const _hoisted_51 = { class: "approvalHeader justify-between flex items-center border-b mx-2 borderBottomStyle" }
const _hoisted_52 = { class: "flex justify-end pl-4 py-1.5" }
const _hoisted_53 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_54 = { class: "p-4" }
const _hoisted_55 = { class: "w-full pb-2" }
const _hoisted_56 = { class: "mt-2" }
const _hoisted_57 = { class: "w-full py-2" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "flex justify-center items-between mt-4" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "mx-3 approvalScroll" }
const _hoisted_63 = { class: "flex" }
const _hoisted_64 = { class: "rounded-full h-8 w-8 flex items-center justify-center cursor-pointer bgColorAndColor" }
const _hoisted_65 = { class: "font-bold text-sm" }
const _hoisted_66 = { class: "flex pl-1 pt-1.5 pb-1" }
const _hoisted_67 = { class: "font-bold cursor-pointer px-2 text-xs" }
const _hoisted_68 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_69 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_70 = {
  key: 2,
  class: "text-xs"
}
const _hoisted_71 = { class: "font-bold cursor-pointer px-2 text-xs" }
const _hoisted_72 = { class: "flex px-11 pt-2.5" }
const _hoisted_73 = {
  key: 0,
  class: "flex pl-11 pt-2.5"
}
const _hoisted_74 = { class: "flex justify-center items-center text-xs ml-2" }
const _hoisted_75 = { key: 3 }
const _hoisted_76 = { class: "card m-2 heightOfInnerdiv overflow-scroll no-scrollbar" }
const _hoisted_77 = { class: "document-container" }
const _hoisted_78 = {
  class: "justify-between flex items-center border-b mx-2 mt-2 pb-2 borderBottomStyle",
  style: {"justify-content":"end"}
}
const _hoisted_79 = { class: "flex" }
const _hoisted_80 = { class: "flex borderStyle border rounded-sm" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { class: "workHistoryScroller" }
const _hoisted_84 = {
  key: 0,
  class: "mx-3"
}
const _hoisted_85 = { class: "initials-container" }
const _hoisted_86 = { class: "rounded-full cursor-pointer h-8 w-8 flex items-center justify-center mr-2 bgColorAndColor" }
const _hoisted_87 = { class: "font-bold text-sm" }
const _hoisted_88 = { class: "toppadding px-11 logContainer" }
const _hoisted_89 = { class: "flex" }
const _hoisted_90 = {
  key: 0,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_91 = {
  key: 1,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_92 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_93 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_94 = {
  key: 4,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_95 = {
  key: 5,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_96 = { class: "mt-1" }
const _hoisted_97 = { class: "flex mt-1" }
const _hoisted_98 = { class: "flex justify-center items-center font-semibold text-xs ml-2" }
const _hoisted_99 = { class: "flex mt-1" }
const _hoisted_100 = { class: "flex justify-center items-center font-semibold text-xs ml-2" }
const _hoisted_101 = { class: "flex mt-1" }
const _hoisted_102 = {
  key: 0,
  class: "min-w-20 flex justify-between"
}
const _hoisted_103 = {
  key: 1,
  class: "flex justify-center items-center ml-2"
}
const _hoisted_104 = ["onClick"]
const _hoisted_105 = ["onClick"]
const _hoisted_106 = {
  key: 1,
  class: "mx-3"
}
const _hoisted_107 = { class: "initials-container" }
const _hoisted_108 = { class: "rounded-full cursor-pointer h-8 w-8 flex items-center justify-center mr-2 bgColorAndColor" }
const _hoisted_109 = { class: "font-bold text-sm" }
const _hoisted_110 = { class: "toppadding px-11 logContainer" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { class: "flex" }
const _hoisted_113 = {
  key: 0,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_114 = {
  key: 1,
  class: "mx-2 text-xs"
}
const _hoisted_115 = {
  key: 2,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_116 = { class: "mt-1" }
const _hoisted_117 = { class: "flex mt-1" }
const _hoisted_118 = { class: "flex justify-center items-center font-semibold text-xs ml-2" }
const _hoisted_119 = { class: "flex mt-1" }
const _hoisted_120 = { class: "flex justify-center items-center font-semibold text-xs ml-2" }
const _hoisted_121 = { class: "flex mt-1" }
const _hoisted_122 = {
  key: 0,
  class: "min-w-20 flex justify-between"
}
const _hoisted_123 = {
  key: 1,
  class: "flex justify-center items-center ml-2"
}
const _hoisted_124 = { key: 1 }
const _hoisted_125 = { class: "flex" }
const _hoisted_126 = {
  key: 0,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_127 = {
  key: 1,
  class: "mx-2 text-xs"
}
const _hoisted_128 = {
  key: 2,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_129 = { class: "mt-1" }
const _hoisted_130 = { class: "flex mt-1" }
const _hoisted_131 = { class: "flex justify-center items-center font-semibold text-xs ml-2" }
const _hoisted_132 = { class: "flex mt-1" }
const _hoisted_133 = { class: "flex justify-center items-center font-semibold text-xs ml-2" }
const _hoisted_134 = { class: "flex mt-1" }
const _hoisted_135 = { class: "ml-2" }
const _hoisted_136 = { class: "flex mt-1" }
const _hoisted_137 = {
  key: 0,
  class: "min-w-20 flex justify-between"
}
const _hoisted_138 = {
  key: 1,
  class: "flex justify-center items-center ml-2"
}
const _hoisted_139 = { key: 2 }
const _hoisted_140 = { class: "flex" }
const _hoisted_141 = {
  key: 0,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_142 = {
  key: 1,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_143 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_144 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_145 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_146 = {
  key: 5,
  class: "mx-2 text-xs"
}
const _hoisted_147 = {
  key: 6,
  class: "mx-2 text-xs"
}
const _hoisted_148 = {
  key: 7,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_149 = {
  key: 8,
  class: "font-semibold cursor-pointer text-xs"
}
const _hoisted_150 = {
  key: 0,
  class: "flex pt-4"
}
const _hoisted_151 = {
  key: 0,
  class: "px-8 pt-1"
}
const _hoisted_152 = { class: "flex flex-row w-full h-full" }
const _hoisted_153 = {
  key: 0,
  class: "editorIconsStyle pt-3 w-full h-full"
}
const _hoisted_154 = { class: "borderBottomStyle mx-2 flex flex-row justify-between mb-2.5 pb-3" }
const _hoisted_155 = { class: "crossIcon h-5 w-5 pt-1 pl-1.5" }
const _hoisted_156 = {
  key: 0,
  class: "ControlsAndSaveIcon w-full flex-col justify-between overflow-y-scroll controlsInnerDiv heightStyles"
}
const _hoisted_157 = {
  key: 0,
  class: "controlsInnerDiv w-full px-2"
}
const _hoisted_158 = { class: "flex justify-center items-center" }
const _hoisted_159 = ["id", "value"]
const _hoisted_160 = { class: "flex items-center cursor-pointer text-xs" }
const _hoisted_161 = ["for"]
const _hoisted_162 = {
  key: 1,
  class: "controlsInnerDiv w-full px-2"
}
const _hoisted_163 = { class: "flex justify-center items-center" }
const _hoisted_164 = ["id", "value"]
const _hoisted_165 = { class: "flex items-center cursor-pointer text-xs" }
const _hoisted_166 = ["for"]
const _hoisted_167 = {
  key: 2,
  class: "controlsInnerDiv w-full px-2"
}
const _hoisted_168 = { class: "flex justify-center items-center" }
const _hoisted_169 = ["id", "value"]
const _hoisted_170 = { class: "flex items-center cursor-pointer text-xs" }
const _hoisted_171 = ["for"]
const _hoisted_172 = {
  key: 3,
  class: "flex justify-center items-end"
}
const _hoisted_173 = {
  key: 1,
  class: "ControlsAndSaveIcon w-full flex-col justify-between overflow-y-auto controlsInnerDiv h-3/4"
}
const _hoisted_174 = {
  key: 0,
  class: "controlsInnerDiv w-full px-2"
}
const _hoisted_175 = { class: "flex justify-center items-center" }
const _hoisted_176 = ["id", "value"]
const _hoisted_177 = { class: "flex items-center cursor-pointer text-xs" }
const _hoisted_178 = ["for"]
const _hoisted_179 = {
  key: 1,
  class: "flex justify-center items-end"
}
const _hoisted_180 = {
  key: 2,
  class: "flex controlsFixedIcon fixed items-center justify-center bg-white"
}
const _hoisted_181 = ["disabled"]
const _hoisted_182 = ["disabled"]
const _hoisted_183 = {
  key: 1,
  class: "editorIconsStyle pt-3 p-2 w-full"
}
const _hoisted_184 = { class: "borderBottomStyle flex flex-row justify-between mb-2.5 pb-3" }
const _hoisted_185 = { class: "crossIcon h-5 w-5 pt-1 pl-1.5" }
const _hoisted_186 = {
  key: 0,
  class: "InnerDiv h-full"
}
const _hoisted_187 = { class: "text-sm mt-2" }
const _hoisted_188 = { class: "mt-3" }
const _hoisted_189 = { class: "text-sm mt-2" }
const _hoisted_190 = { class: "mt-3" }
const _hoisted_191 = { class: "text-sm mt-2" }
const _hoisted_192 = { class: "mt-3" }
const _hoisted_193 = { class: "text-sm mt-2" }
const _hoisted_194 = { class: "mt-3" }
const _hoisted_195 = { class: "text-sm mt-2" }
const _hoisted_196 = { class: "mt-3" }
const _hoisted_197 = { class: "text-sm mt-2" }
const _hoisted_198 = {
  key: 0,
  class: "flex justify-center align-center pt-5"
}
const _hoisted_199 = { key: 1 }
const _hoisted_200 = { class: "mt-3" }
const _hoisted_201 = { class: "text-sm mt-2" }
const _hoisted_202 = { class: "mt-3" }
const _hoisted_203 = { class: "text-sm mt-2" }
const _hoisted_204 = { class: "mt-3" }
const _hoisted_205 = { class: "text-sm mt-2" }
const _hoisted_206 = { class: "mt-3" }
const _hoisted_207 = { class: "text-sm mt-2" }
const _hoisted_208 = { class: "mt-3" }
const _hoisted_209 = { class: "text-sm mt-2" }
const _hoisted_210 = {
  key: 0,
  class: "flex justify-center align-center pt-5"
}
const _hoisted_211 = {
  key: 2,
  class: "InnerDiv h-full"
}
const _hoisted_212 = { class: "text-white text-sm" }
const _hoisted_213 = { class: "upperspacing" }
const _hoisted_214 = { class: "text-sm mt-2" }
const _hoisted_215 = { class: "upperspacing" }
const _hoisted_216 = { class: "text-sm mt-2" }
const _hoisted_217 = { class: "upperspacing" }
const _hoisted_218 = { class: "text-sm mt-2" }
const _hoisted_219 = { class: "upperspacing" }
const _hoisted_220 = { class: "text-sm mt-2" }
const _hoisted_221 = {
  key: 2,
  class: "editorIconsStyle pt-3 w-full"
}
const _hoisted_222 = { class: "px-2" }
const _hoisted_223 = { class: "borderBottomStyle flex flex-row justify-between mb-2.5 pb-3 relative" }
const _hoisted_224 = { class: "crossIcon h-5 w-5 pt-1 pl-1.5 absolute top-0 right-0" }
const _hoisted_225 = { class: "h-full flex flex-col justify-items-stretch gap-6" }
const _hoisted_226 = { class: "commentscrollable-container pb-2 mb-8" }
const _hoisted_227 = { class: "addedMessage px-2" }
const _hoisted_228 = { class: "pr-1 relative" }
const _hoisted_229 = { class: "flex justify-between items-center mb-0.5" }
const _hoisted_230 = { class: "flex items-center" }
const _hoisted_231 = { class: "nk-icon transform translate-x-1/2 translate-y-1/2 absolute fontSizing rounded-full active w-5 h-5 flex justify-center items-center mr-2" }
const _hoisted_232 = { class: "flex items-center" }
const _hoisted_233 = { class: "comment-name ml-1.5 text-sm font-bold mr-auto" }
const _hoisted_234 = { class: "flex items-center" }
const _hoisted_235 = { class: "comment-date ml-1.5 text-xs text-gray-500" }
const _hoisted_236 = { class: "text-xs mt-1.5" }
const _hoisted_237 = { class: "sticky bottomGap" }
const _hoisted_238 = {
  key: 3,
  class: "editorIconsStyle pt-3 pl-2 pb-2 w-full"
}
const _hoisted_239 = { class: "borderBottomStyle flex flex-row justify-between mb-2.5 pb-3 relative" }
const _hoisted_240 = { class: "crossIcon h-5 w-5 pt-1 pl-1.5 absolute top-0 right-0" }
const _hoisted_241 = {
  class: "workFlowScroll",
  style: {"height":"72%"}
}
const _hoisted_242 = { class: "steps steps-vertical" }
const _hoisted_243 = {
  key: 0,
  class: "text-xs text-start"
}
const _hoisted_244 = { class: "flex" }
const _hoisted_245 = { class: "workflow" }
const _hoisted_246 = { key: 0 }
const _hoisted_247 = { key: 1 }
const _hoisted_248 = {
  key: 0,
  class: "cursor-pointer date_settings"
}
const _hoisted_249 = {
  key: 1,
  class: "cursor-pointer date_settings"
}
const _hoisted_250 = { class: "rightSideBar borderStyle h-full borderBottomStyle" }
const _hoisted_251 = ["onClick"]
const _hoisted_252 = { class: "flex justify-center items-center mt-2 mb-2 cursor-pointer" }
const _hoisted_253 = {
  key: 0,
  class: "bg-tooltip absolute z-50 group-hover:opacity-100 border rounded tooltipwidth pointer-events-none transform-y-top right-11 whitespace-nowrap"
}
const _hoisted_254 = { class: "flex justify-center items-center mt-2 mb-2 cursor-pointer" }
const _hoisted_255 = {
  key: 0,
  class: "bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth border pointer-events-none transform-y-top right-11 whitespace-nowrap"
}
const _hoisted_256 = { class: "flex justify-center items-center mt-2 mb-2 cursor-pointer" }
const _hoisted_257 = {
  key: 0,
  class: "bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth border pointer-events-none transform-y-top right-11 whitespace-nowrap"
}
const _hoisted_258 = { class: "flex justify-center items-center mt-2 mb-2 cursor-pointer" }
const _hoisted_259 = {
  key: 0,
  class: "bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth border pointer-events-none transform-y-top right-11 whitespace-nowrap"
}
const _hoisted_260 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_261 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_262 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_263 = { class: "w-full" }
const _hoisted_264 = { class: "inputboxstyling mt-2" }
const _hoisted_265 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_266 = { class: "w-6/12" }
const _hoisted_267 = { class: "inputboxstyling mt-2" }
const _hoisted_268 = { class: "w-6/12 leftspacing" }
const _hoisted_269 = { class: "inputboxstyling mt-2" }
const _hoisted_270 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_271 = { class: "row flex flex-row w-full" }
const _hoisted_272 = { class: "w-6/12" }
const _hoisted_273 = ["value"]
const _hoisted_274 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_275 = {
  key: 0,
  class: "error-text"
}
const _hoisted_276 = { class: "w-3/6 leftspacing" }
const _hoisted_277 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_278 = {
  key: 0,
  class: "error-text"
}
const _hoisted_279 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_280 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_281 = { class: "w-6/12" }
const _hoisted_282 = ["value"]
const _hoisted_283 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_284 = {
  key: 0,
  class: "error-text"
}
const _hoisted_285 = { class: "w-3/6 leftspacing" }
const _hoisted_286 = { class: "mt-2" }
const _hoisted_287 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_288 = {
  key: 0,
  class: "error-text"
}
const _hoisted_289 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_290 = { class: "w-6/12" }
const _hoisted_291 = ["value"]
const _hoisted_292 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_293 = {
  key: 0,
  class: "error-text"
}
const _hoisted_294 = { class: "w-3/6 leftspacing" }
const _hoisted_295 = { class: "mt-2" }
const _hoisted_296 = { class: "upperspacing" }
const _hoisted_297 = { class: "w-auto bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden mt-2" }
const _hoisted_298 = {
  key: 0,
  id: "fileNameSpan",
  class: "placeholder-styles items-center justify-between flex"
}
const _hoisted_299 = {
  key: 1,
  id: "fileNameSpan",
  class: "placeholder-styles items-center justify-between flex"
}
const _hoisted_300 = {
  key: 2,
  id: "fileNameSpan",
  class: "placeholder-styles items-center justify-between flex"
}
const _hoisted_301 = { class: "buttonposition flex justify-center items-center mb-4 mx-0" }
const _hoisted_302 = ["disabled"]
const _hoisted_303 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_popup = _resolveComponent("popup")!
  const _component_readOnlyDocumentEditor = _resolveComponent("readOnlyDocumentEditor")!
  const _component_docmentEditor = _resolveComponent("docmentEditor")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["font-bold", _ctx.titleLength > 40? 'w-72 table-ellipsis':''])
              }, _toDisplayString(_ctx.presentDocumentData.documentName), 3),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.presentDocumentData.classification)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center justify-center relative rounded w-24 h-5 regular", _ctx.colorTextClasificationStatus(_ctx.presentDocumentData.classification)])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full h-full absolute opacity-10 rounded", _ctx.colorBgClasificationStatus(_ctx.presentDocumentData.classification)])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.presentDocumentData.classification == 4 ? 'highlyConfidentialStyling' : 'text-xs')
                          }, _toDisplayString(_ctx.classificationData.find((l) => {
														return l.id == _ctx.presentDocumentData.classification;
													}).value), 3)
                        ])
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.presentDocumentData.statusCode && _ctx.$route.params.type != 'archivedocuments' && _ctx.$route.params.type != 'fileslist')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center justify-center relative rounded w-24 px-2.5 h-5 regular", _ctx.colorTextRequestStatus(_ctx.presentDocumentData.statusCode)])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full h-full absolute opacity-10 rounded", _ctx.colorBgRequestStatus(_ctx.presentDocumentData.statusCode)])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.docStatusValues.find((l) => {
														return l.id == _ctx.presentDocumentData.statusCode;
													}).value), 1)
                        ])
                      ], 2)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.routeRoleBased)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["rounded font-opensans font-bold text-sm px-2.5 py-2.5 leading-3 cursor-pointer text-white", _ctx.approveRejectBtns == true ? 'approvebtn' : 'btndisabled pointer-events-none']),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveOrReject(10408)))
                    }, "Approve", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["rounded font-opensans font-bold text-sm px-2.5 py-2.5 leading-3 cursor-pointer text-white", _ctx.approveRejectBtns == true ? 'rejectbtn' : 'btndisabled pointer-events-none']),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approveOrReject(10410)))
                    }, "Reject", 2)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$route.params.type == 'myDocuments' && _ctx.authorRoleBased == true && (_ctx.presentDocumentData.statusCode === 10408 || _ctx.presentDocumentData.statusCode === 10413))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btnprimary ml-2 flex items-center",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPopupByReversion && _ctx.showPopupByReversion(...args)))
                  }, "Reversion"))
                : _createCommentVNode("", true),
              (_ctx.authorRoleBased == true && _ctx.$route.params.type === 'myDocuments' && _ctx.presentDocumentData.statusCode === 10408)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: _normalizeClass(["ml-4", _ctx.publish ? 'btnprimary rounded font-opensans font-bold text-sm px-2.5 py-2.5 leading-3 cursor-pointer text-white' : 'btndisabled pointer-events-none']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.publishAction()))
                  }, " Publish ", 2))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _cache[59] || (_cache[59] = _createElementVNode("div", { class: "headerText mt-3" }, " Document management, often referred to as Document Management Systems (DMS), is the use of a computer system and software to store, manage and track electronic documents and electronic images of paper-based information captured through the use of a document ", -1))
      ]),
      (_ctx.approveAndRejectPopUp)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 0,
            popUp: _ctx.approveAndRejectPopUp
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h1", {
                  class: _normalizeClass(["pl-2 w-72", _ctx.titleLength > 40? 'table-ellipsis':''])
                }, _toDisplayString(_ctx.presentDocumentData.documentName), 3),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.CancelButtonPermissionPopUp('close')))
                }, _cache[60] || (_cache[60] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[62] || (_cache[62] = _createElementVNode("label", { class: "controllabel text-xs" }, "Justification by Approver", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: _normalizeClass(["inputboxstyling h-50 mt-2", {'is-invalid': _ctx.v$.justification.$error || _ctx.displayErrorMessage == true }]),
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.justification) = $event)),
                              placeholder: "Justification",
                              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.restrictCharacters('approval')))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.justification,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.displayErrorMessage == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[61] || (_cache[61] = [
                                  _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("button", {
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary mr-1.5", { 'btndisabled pointer-events-none': _ctx.justification === '' || _ctx.justification === null }]),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onCancelbtn()))
                          }, "Cancel", 10, _hoisted_22),
                          _createElementVNode("button", {
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary", { 'btndisabled pointer-events-none': _ctx.justification === '' || _ctx.justification === null }]),
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveApproveAndRejectData(_ctx.statusCode)))
                          }, "Save", 10, _hoisted_23)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", {
            class: _normalizeClass([!_ctx.showComments && !_ctx.showControls && !_ctx.showDocumentInfo && !_ctx.showWorkFlow ? 'w-full' : 'middleDivWidth', "px-2 text-sm middleDiv relative"])
          }, [
            (_ctx.isSmallScreen && !(_ctx.$route.params.type == 'fileslist' || _ctx.$route.params.type == 'archivedocuments'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["absolute left-0 cursor-pointer top-3", { 'disabled pointer-events-none': (_ctx.selectedTabIndex === 0 || _ctx.currentGroupIndex === 0) && _ctx.isSmallScreen }]),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.scrollTabs('left')))
                  }, _cache[63] || (_cache[63] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "arrow left-0",
                      style: {"width":"16px","margin-left":"3px","top":"13px"}
                    }, null, -1)
                  ]), 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["absolute right-0 cursor-pointer top-3", { 'disabled pointer-events-none': (_ctx.selectedTabIndex === _ctx.tabHead.length || _ctx.currentGroupIndex >= _ctx.totalGroups - 1) && _ctx.isSmallScreen }]),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.scrollTabs('right')))
                  }, _cache[64] || (_cache[64] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "arrow right-0",
                      style: {"width":"16px","margin-right":"3px","top":"13px"}
                    }, null, -1)
                  ]), 2)
                ]))
              : (!(_ctx.$route.params.type == 'fileslist' || _ctx.$route.params.type == 'archivedocuments'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute left-0 cursor-pointer top-3", { 'disabled pointer-events-none': !_ctx.canScrollLeft && !_ctx.isSmallScreen }]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.scrollTabs('left')))
                    }, _cache[65] || (_cache[65] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "arrow left-0",
                        style: {"width":"16px","margin-left":"3px","top":"13px"}
                      }, null, -1)
                    ]), 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["absolute right-0 cursor-pointer top-3", { 'disabled pointer-events-none': !_ctx.canScrollRight && !_ctx.isSmallScreen }]),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.scrollTabs('right')))
                    }, _cache[66] || (_cache[66] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "arrow right-0",
                        style: {"width":"16px","margin-right":"3px","top":"13px"}
                      }, null, -1)
                    ]), 2)
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_ctx.$route.params.type == 'fileslist' || _ctx.$route.params.type == 'archivedocuments')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab, tabIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["pb-1", _ctx.selectedTabIndex == tab.id ? 'adjust font-semibold':'text-sm text-disabledgrey']),
                        key: tabIndex,
                        onClick: ($event: any) => (_ctx.toggleTabs(tab))
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ 'text-blue': _ctx.selectedTabIndex === tab.id }),
                            ref_for: true,
                            ref: "actualIndex"
                          }, _toDisplayString(tab.displayName), 3),
                          _createElementVNode("div", {
                            class: _normalizeClass([{ progress: _ctx.selectedTabIndex === tab.id }, "h-1 p-0.75"]),
                            style: {"z-index":"1"}
                          }, null, 2)
                        ])
                      ], 10, _hoisted_30))
                    }), 128))
                  ], 512)),
              (_ctx.$route.params.type != 'fileslist' && _ctx.$route.params.type != 'archivedocuments')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (_ctx.selectedTabIndex == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    (_ctx.renderUrl != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-full mt-2 px-2", _ctx.docPerviewStyles() ? 'fileMiddleDivScroll': 'docMiddleDivScroll'])
                          }, [
                            _createElementVNode("object", {
                              class: "pdf middleDivWidth rounded",
                              data: _ctx.renderUrl
                            }, null, 8, _hoisted_34)
                          ], 2)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.showFullToolbar == true ? '': 'card px-4 heightOfInnerdiv overflow-scroll no-scrollbar')
                          }, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["w-full", _ctx.docPerviewStyles() ? 'fileMiddleDivScroll px-2': 'docMiddleDivScroll'])
                                }, [
                                  (_ctx.showFullToolbar == true)
                                    ? (_openBlock(), _createBlock(_component_readOnlyDocumentEditor, {
                                        key: 0,
                                        data: _ctx.currentDocument
                                      }, null, 8, ["data"]))
                                    : (_openBlock(), _createBlock(_component_docmentEditor, {
                                        key: 1,
                                        data: _ctx.currentDocument.content
                                      }, null, 8, ["data"]))
                                ], 2)
                              ])
                            ])
                          ], 2)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedTabIndex == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      (_ctx.previousDocuments != [] && _ctx.previousDocuments.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _cache[67] || (_cache[67] = [
                            _createElementVNode("p", { class: "text-black" }, "No documents found", -1)
                          ])))
                        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previousDocuments, (doc) => {
                              return (_openBlock(), _createElementBlock("div", { key: doc }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(doc.url || doc.content ? 'pdf w-full rounded-sm' : '')
                                }, [
                                  (doc.url)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.clickedFileUrl(doc.url, doc.versionId, 'clickHere')),
                                          download: "document",
                                          class: "flex w-full flex-row items-center"
                                        }, [
                                          _cache[68] || (_cache[68] = _createElementVNode("img", {
                                            src: _imports_3,
                                            alt: ""
                                          }, null, -1)),
                                          _createElementVNode("p", _hoisted_44, _toDisplayString(doc.docVersion || 'Document'), 1)
                                        ], 8, _hoisted_43)
                                      ]))
                                    : (doc.content)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                          _createElementVNode("div", {
                                            class: "flex w-full flex-row items-center",
                                            onClick: ($event: any) => (_ctx.downloadHtmlAsPdf(doc.content, doc.docVersion, 'base64'))
                                          }, [
                                            _cache[69] || (_cache[69] = _createElementVNode("img", {
                                              src: _imports_3,
                                              alt: ""
                                            }, null, -1)),
                                            _createElementVNode("p", _hoisted_47, _toDisplayString(doc.docVersion || 'Document'), 1)
                                          ], 8, _hoisted_46)
                                        ]))
                                      : _createCommentVNode("", true)
                                ], 2)
                              ]))
                            }), 128))
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedTabIndex == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_51, [
                            _cache[76] || (_cache[76] = _createElementVNode("div", null, null, -1)),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  class: _normalizeClass([_ctx.presentDocumentData.statusCode != 10411 || _ctx.authorRoleBased === false ? 'btndisabled disabledTaskEditButtons pointer-events-none' : 'btnprimary taskEditButtons', "btnprimary cursor-pointer"]),
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showApproval()))
                                }, "Send Approval", 2)
                              ]),
                              (_ctx.showApprovalPopUp)
                                ? (_openBlock(), _createBlock(_component_popup, {
                                    key: 0,
                                    popUp: _ctx.showApprovalPopUp
                                  }, {
                                    header: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_53, [
                                        _cache[71] || (_cache[71] = _createElementVNode("h1", { class: "pl-2" }, "For Approval", -1)),
                                        _createElementVNode("button", {
                                          class: "float-right text-3xl",
                                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onCancelButtonAddPopUp('close')))
                                        }, _cache[70] || (_cache[70] = [
                                          _createElementVNode("img", {
                                            src: _imports_0,
                                            class: "h-5 w-5 cursor-pointer"
                                          }, null, -1)
                                        ]))
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("fieldset", null, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("div", _hoisted_55, [
                                            _cache[73] || (_cache[73] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                                            _createElementVNode("div", _hoisted_56, [
                                              _createVNode(_component_Multiselect, {
                                                modelValue: _ctx.approvalComment.owner,
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.approvalComment.owner) = $event)),
                                                options: _ctx.optionsUsersList,
                                                multiple: false,
                                                "close-on-select": true,
                                                "clear-on-select": true,
                                                label: "label",
                                                "track-by": "value",
                                                searchable: true,
                                                hideArrow: false,
                                                placeholder: "Owner",
                                                deselectLabel: "",
                                                selectLabel: "",
                                                class: _normalizeClass(["custom-multiselect", {
																			'has-options': _ctx.optionsUsersList && _ctx.optionsUsersList.length > 0,
																			'no-options':  !_ctx.optionsUsersList.length
																		}])
                                              }, {
                                                noResult: _withCtx(() => _cache[72] || (_cache[72] = [
                                                  _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                                ])),
                                                _: 1
                                              }, 8, ["modelValue", "options", "class"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_57, [
                                            _cache[75] || (_cache[75] = _createElementVNode("label", { class: "controllabel" }, "Approval Comment", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                              class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.approvalComment.comments.$error || _ctx.displayErrorMessage == true}]),
                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.approvalComment.comments) = $event)),
                                              placeholder: "Comment",
                                              onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.restrictCharacters('request')))
                                            }, null, 34), [
                                              [
                                                _vModelText,
                                                _ctx.approvalComment.comments,
                                                void 0,
                                                { trim: true }
                                              ]
                                            ]),
                                            (_ctx.displayErrorMessage == true)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, _cache[74] || (_cache[74] = [
                                                  _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                                ])))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("button", {
                                          disabled: _ctx.clickOnButton,
                                          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.cancelComments && _ctx.cancelComments(...args))),
                                          class: _normalizeClass(["mr-1.5", _ctx.approvalComment.comments == '' && _ctx.approvalComment.owner == '' ? 'btndisabled pointer-events-none' : 'btnprimary'])
                                        }, "Cancel", 10, _hoisted_60),
                                        _createElementVNode("button", {
                                          disabled: _ctx.clickOnButton,
                                          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.saveComments && _ctx.saveComments(...args))),
                                          class: _normalizeClass(["btnprimary", _ctx.approvalComment.comments == '' && _ctx.approvalComment.owner == '' ? 'btndisabled pointer-events-none' : 'btnprimary'])
                                        }, "Save", 10, _hoisted_61)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["popUp"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Approvals, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "py-4 px-2 borderBottomStyle"
                            }, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.getInitials(item.createdby)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.getUserName(item.createdby)), 1),
                                  (item.statusCode == 10415)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString('raised a request for approval at')))
                                    : (item.statusCode == 10408)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString('accepted the approval at')))
                                      : (item.statusCode == 10413)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString('published the document on')))
                                        : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.formatTime(item.createdAt)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                (Object.keys(item).includes('previousStatusCode'))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 text-xs", _ctx.workflow_color(item.previousStatusCode)])
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.workflow_text(item.previousStatusCode))
                                      }, [
                                        _createElementVNode("b", null, _toDisplayString(_ctx.statusValue.find((l) => {
																		return l.id == item.previousStatusCode;
																	}).status), 1)
                                      ], 2)
                                    ], 2))
                                  : _createCommentVNode("", true),
                                (!Object.keys(item).includes('previousStatusCode'))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 text-xs", _ctx.workflow_color(10411)])
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.workflow_text(10411))
                                      }, _cache[77] || (_cache[77] = [
                                        _createElementVNode("b", null, _toDisplayString('Draft'), -1)
                                      ]), 2)
                                    ], 2))
                                  : _createCommentVNode("", true),
                                _cache[78] || (_cache[78] = _createElementVNode("div", { class: "px-8 pt-1" }, [
                                  _createElementVNode("img", { src: _imports_4 })
                                ], -1)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 text-xs", _ctx.workflow_color(item.statusCode)])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.workflow_text(item.statusCode))
                                  }, [
                                    _createElementVNode("b", null, _toDisplayString(_ctx.statusValue.find((l) => {
																		return l.id == item.statusCode;
																	}).status), 1)
                                  ], 2)
                                ], 2)
                              ]),
                              (item.comments && item.comments !== '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                    _cache[79] || (_cache[79] = _createElementVNode("div", { class: "max-w-20 flex font-semibold justify-between" }, [
                                      _createElementVNode("span", { class: "text-xs pt-0.5" }, "Comments"),
                                      _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'))
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_74, _toDisplayString(item.comments), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedTabIndex == 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("button", {
                                class: _normalizeClass([{ 'active-tab': _ctx.activeButton === 'revision', 'inactive-tab': _ctx.activeButton !== 'revision' }, "flex items-center font-semibold fontSizing justify-center rounded p-px leading-3 cursor-pointer w-28 h-7"]),
                                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.showRevisionHistory && _ctx.showRevisionHistory(...args)))
                              }, [
                                (_ctx.activeButton === 'revision')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_81))
                                  : _createCommentVNode("", true),
                                _cache[80] || (_cache[80] = _createTextVNode(" Revision History "))
                              ], 2),
                              _createElementVNode("button", {
                                class: _normalizeClass([{ 'active-tab': _ctx.activeButton === 'details', 'inactive-tab': _ctx.activeButton !== 'details' }, "flex items-center fontSizing font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-7"]),
                                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.showDetails && _ctx.showDetails(...args)))
                              }, [
                                (_ctx.activeButton === 'details')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82))
                                  : _createCommentVNode("", true),
                                _cache[81] || (_cache[81] = _createTextVNode(" Details "))
                              ], 2)
                            ]),
                            (_ctx.sortOrder)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "p-2 w-24 h-7 sortOrderborderStyle rounded-sm flex items-center justify-center p-2 ml-3.5 font-semibold",
                                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.showNewest && _ctx.showNewest(...args)))
                                }, _cache[82] || (_cache[82] = [
                                  _createElementVNode("img", {
                                    src: _imports_5,
                                    class: "h-3 mr-2.5 rotate-180"
                                  }, null, -1),
                                  _createTextVNode(" Oldest ")
                                ])))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "p-2 w-24 h-7 border rounded-sm flex items-center sortOrderborderStyle justify-center p-2 ml-3.5 font-semibold",
                                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.showNewest && _ctx.showNewest(...args)))
                                }, _cache[83] || (_cache[83] = [
                                  _createElementVNode("img", {
                                    src: _imports_5,
                                    class: "h-3 mr-2.5"
                                  }, null, -1),
                                  _createTextVNode(" Newest ")
                                ])))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        (_ctx.revisionList)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentHistoryArray, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "py-4 px-2 borderBottomStyle"
                                }, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("div", _hoisted_86, [
                                      _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.getInitialsForHistory(item, 'createdBy', 'updatedBy')), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("div", _hoisted_89, [
                                      (Object.keys(item).includes('createdBy'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_ctx.getUserName(item.createdBy)), 1))
                                        : _createCommentVNode("", true),
                                      (Object.keys(item).includes('updatedBy'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString(_ctx.getUserName(item.updatedBy)), 1))
                                        : _createCommentVNode("", true),
                                      (Object.keys(item).includes('createdBy'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_92, _toDisplayString('Created the Document on')))
                                        : _createCommentVNode("", true),
                                      (Object.keys(item).includes('updatedBy'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString('Updated the Document on')))
                                        : _createCommentVNode("", true),
                                      (Object.keys(item).includes('updatedAt'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_94, _toDisplayString(_ctx.formatTime(item.updatedAt)), 1))
                                        : _createCommentVNode("", true),
                                      (Object.keys(item).includes('createdAt'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString(_ctx.formatTime(item.createdAt)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_96, [
                                      _createElementVNode("div", _hoisted_97, [
                                        _cache[84] || (_cache[84] = _createElementVNode("div", { class: "min-w-20 flex justify-between" }, [
                                          _createElementVNode("span", { class: "text-xs pt-0.5" }, "Version"),
                                          _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'))
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_98, _toDisplayString(item.docVersion), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_99, [
                                        _cache[85] || (_cache[85] = _createElementVNode("div", { class: "min-w-20 flex justify-between" }, [
                                          _createElementVNode("span", { class: "text-xs pt-0.5" }, "Author"),
                                          _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'))
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.getUserName(_ctx.presentDocumentData.createdBy)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_101, [
                                        (item.statusCode == 10413)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, _cache[86] || (_cache[86] = [
                                              _createElementVNode("span", { class: "text-xs" }, "File", -1),
                                              _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'), -1)
                                            ])))
                                          : _createCommentVNode("", true),
                                        (item.statusCode == 10413)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                              (item.url)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "mr-2 cursor-pointer fileUrlClick",
                                                    onClick: ($event: any) => (_ctx.clickedFileUrl(item.url, item.versionId, 'clickHere'))
                                                  }, _toDisplayString('Click Here'), 8, _hoisted_104))
                                                : (item.content)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 1,
                                                      class: "mr-2 cursor-pointer fileUrlClick",
                                                      onClick: ($event: any) => (_ctx.downloadHtmlAsPdf(item.content, item.docVersion, 'workHistory'))
                                                    }, _toDisplayString('Click Here'), 8, _hoisted_105))
                                                  : _createCommentVNode("", true),
                                              _cache[87] || (_cache[87] = _createElementVNode("p", { class: "text-xs" }, _toDisplayString('for the Document'), -1))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.showArray)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentHistoryArray, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "py-4 px-2 borderBottomStyle"
                                }, [
                                  _createElementVNode("div", _hoisted_107, [
                                    _createElementVNode("div", _hoisted_108, [
                                      _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.getInitialsForHistory(item, 'createdBy', 'updatedBy')), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_110, [
                                    (item.actionEntity == 10301 && item.statusCode == 10411)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                          _createElementVNode("div", _hoisted_112, [
                                            (Object.keys(item).includes('createdBy') && item.actionEntity == 10301)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_113, _toDisplayString(_ctx.getUserName(item.createdBy)), 1))
                                              : _createCommentVNode("", true),
                                            (!Object.keys(item).includes('previousStatus') && item.actionEntity == 10301)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_114, _toDisplayString('Created the Document on')))
                                              : _createCommentVNode("", true),
                                            (Object.keys(item).includes('createdAt'))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_115, _toDisplayString(_ctx.formatTime(item.createdAt)), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_116, [
                                            _createElementVNode("div", _hoisted_117, [
                                              _cache[88] || (_cache[88] = _createElementVNode("div", { class: "min-w-20 flex justify-between" }, [
                                                _createElementVNode("span", { class: "text-xs pt-0.5" }, "Version"),
                                                _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'))
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.presentDocumentData.version), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_119, [
                                              _cache[89] || (_cache[89] = _createElementVNode("div", { class: "min-w-20 flex justify-between" }, [
                                                _createElementVNode("span", { class: "text-xs pt-0.5" }, "Author"),
                                                _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'))
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.getUserName(_ctx.presentDocumentData.createdBy)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_121, [
                                              (_ctx.presentDocumentData.statusCode == 10413)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_122, _cache[90] || (_cache[90] = [
                                                    _createElementVNode("span", { class: "text-xs" }, "File", -1),
                                                    _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'), -1)
                                                  ])))
                                                : _createCommentVNode("", true),
                                              (_ctx.presentDocumentData.statusCode == 10413)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                                    (_ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].url)
                                                      ? (_openBlock(), _createElementBlock("div", {
                                                          key: 0,
                                                          class: "mr-2 cursor-pointer fileUrlClick",
                                                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.clickedFileUrl(_ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].url, _ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].versionId, 'clickHere')))
                                                        }, _toDisplayString('Click Here')))
                                                      : (_ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].content)
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 1,
                                                            class: "mr-2 cursor-pointer fileUrlClick",
                                                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.downloadHtmlAsPdf(_ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].content, _ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].docVersion, 'workHistory')))
                                                          }, _toDisplayString('Click Here')))
                                                        : _createCommentVNode("", true),
                                                    _cache[91] || (_cache[91] = _createElementVNode("p", { class: "text-xs" }, _toDisplayString('for the Document'), -1))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]))
                                      : (item.actionEntity == 10302 && item.statusCode == 10411)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                            _createElementVNode("div", _hoisted_125, [
                                              (Object.keys(item).includes('updatedBy') && item.actionEntity == 10302)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_126, _toDisplayString(_ctx.getUserName(item.updatedBy)), 1))
                                                : _createCommentVNode("", true),
                                              (!Object.keys(item).includes('previousStatus') && item.actionEntity == 10302)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_127, _toDisplayString('Updated the Document on')))
                                                : _createCommentVNode("", true),
                                              (Object.keys(item).includes('updatedAt'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_128, _toDisplayString(_ctx.formatTime(item.updatedAt)), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_129, [
                                              _createElementVNode("div", _hoisted_130, [
                                                _cache[92] || (_cache[92] = _createElementVNode("div", { class: "min-w-20 flex justify-between" }, [
                                                  _createElementVNode("span", { class: "text-xs" }, "Version"),
                                                  _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'))
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.presentDocumentData.version), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_132, [
                                                _cache[93] || (_cache[93] = _createElementVNode("div", { class: "min-w-20 flex justify-between" }, [
                                                  _createElementVNode("span", { class: "text-xs" }, "Author"),
                                                  _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'))
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.getUserName(_ctx.presentDocumentData.createdBy)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_134, [
                                                _cache[94] || (_cache[94] = _createElementVNode("div", { class: "min-w-20 flex justify-between" }, [
                                                  _createElementVNode("span", { class: "text-xs" }, "Status"),
                                                  _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'))
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_135, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 text-xs", _ctx.workflow_color(10411)])
                                                  }, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass([_ctx.workflow_text(10411), "text-xs"])
                                                    }, [
                                                      _createElementVNode("b", null, _toDisplayString(_ctx.statusValue.find((l) => {
																					return l.id == 10411;
																				}).status), 1)
                                                    ], 2)
                                                  ], 2)
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_136, [
                                                (_ctx.presentDocumentData.statusCode == 10413)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, _cache[95] || (_cache[95] = [
                                                      _createElementVNode("span", null, "File", -1),
                                                      _createElementVNode("span", { class: "ml-2" }, _toDisplayString(':'), -1)
                                                    ])))
                                                  : _createCommentVNode("", true),
                                                (_ctx.presentDocumentData.statusCode == 10413)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                                      (_ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].url)
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: "mr-2 cursor-pointer fileUrlClick",
                                                            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.clickedFileUrl(_ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].url, _ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].versionId, 'clickHere')))
                                                          }, _toDisplayString('Click Here')))
                                                        : (_ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].content)
                                                          ? (_openBlock(), _createElementBlock("div", {
                                                              key: 1,
                                                              class: "mr-2 cursor-pointer fileUrlClick",
                                                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.downloadHtmlAsPdf(_ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].content, _ctx.presentDocumentData.documentUrl[_ctx.presentDocumentData.documentUrl.length - 1].docVersion, 'workHistory')))
                                                            }, _toDisplayString('Click Here')))
                                                          : _createCommentVNode("", true),
                                                      _cache[96] || (_cache[96] = _createElementVNode("p", { class: "text-xs" }, _toDisplayString('for the Document'), -1))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                            _createElementVNode("div", _hoisted_140, [
                                              (Object.keys(item).includes('updatedBy'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_141, _toDisplayString(_ctx.getUserName(item.updatedBy)), 1))
                                                : _createCommentVNode("", true),
                                              (Object.keys(item).includes('createdBy'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_142, _toDisplayString(_ctx.getUserName(item.createdBy)), 1))
                                                : _createCommentVNode("", true),
                                              (item.statusCode == 10415)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_143, _toDisplayString('Sent the Document for Approval on')))
                                                : (item.statusCode == 10408)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_144, _toDisplayString('Approved the Document on')))
                                                  : (item.statusCode == 10410)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_145, _toDisplayString('Rejected the Document on')))
                                                    : (item.statusCode == 10413)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_146, _toDisplayString('Published the Document on')))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_147, _toDisplayString('Updated the Document on'))),
                                              (Object.keys(item).includes('updatedAt'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_148, _toDisplayString(_ctx.formatTime(item.updatedAt)), 1))
                                                : _createCommentVNode("", true),
                                              (Object.keys(item).includes('createdAt'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_149, _toDisplayString(_ctx.formatTime(item.createdAt)), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (Object.keys(item).includes('previousStatusCode'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 text-xs", _ctx.workflow_color(item.previousStatusCode)])
                                                  }, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass([_ctx.workflow_text(item.previousStatusCode), "text-xs"])
                                                    }, [
                                                      _createElementVNode("b", null, _toDisplayString(_ctx.statusValue.find((l) => {
																			return l.id == item.previousStatusCode;
																		}).status), 1)
                                                    ], 2)
                                                  ], 2),
                                                  (Object.keys(item).includes('statusCode'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_151, _cache[97] || (_cache[97] = [
                                                        _createElementVNode("img", { src: _imports_4 }, null, -1)
                                                      ])))
                                                    : _createCommentVNode("", true),
                                                  (Object.keys(item).includes('statusCode'))
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 1,
                                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 text-xs", _ctx.workflow_color(item.statusCode)])
                                                      }, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass([_ctx.workflow_text(item.statusCode), "text-xs"])
                                                        }, [
                                                          _createElementVNode("b", null, _toDisplayString(_ctx.statusValue.find((l) => {
																				return l.id == item.statusCode;
																			}).status), 1)
                                                        ], 2)
                                                      ], 2))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["iconContainer h-auto", !_ctx.showComments && !_ctx.showControls && !_ctx.showDocumentInfo && !_ctx.showWorkFlow ? 'flex justify-end' : 'iconContainerWidth'])
          }, [
            _createElementVNode("div", _hoisted_152, [
              (_ctx.showControls)
                ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                    _createElementVNode("div", _hoisted_154, [
                      _cache[98] || (_cache[98] = _createElementVNode("div", { class: "font-semibold" }, [
                        _createElementVNode("h5", null, "Controls")
                      ], -1)),
                      _createElementVNode("div", _hoisted_155, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "h-4 w-4 cursor-pointer",
                          onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.toggleControls && _ctx.toggleControls(...args)))
                        })
                      ])
                    ]),
                    (_ctx.authorRoleBased === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                          (_ctx.allControlsData.length != 0 && _ctx.presentDocumentData.statusCode === 10411 && _ctx.$route.params.type === 'myDocuments')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlsData, (control) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "flex my-2",
                                    key: control._id
                                  }, [
                                    _createElementVNode("div", _hoisted_158, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "checkbox mr-2",
                                        id: control._id,
                                        value: control._id,
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.mappedControlsForDocument) = $event))
                                      }, null, 8, _hoisted_159), [
                                        [_vModelCheckbox, _ctx.mappedControlsForDocument]
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_160, [
                                      _createElementVNode("label", {
                                        for: control._id
                                      }, _toDisplayString(control.controlTitle), 9, _hoisted_161)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : (_ctx.allControlsData.length != 0 && (_ctx.presentDocumentData.statusCode === 10415 || _ctx.presentDocumentData.statusCode === 10408) && _ctx.$route.params.type === 'myDocuments')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlsData, (control) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "flex my-2",
                                      key: control._id
                                    }, [
                                      _createElementVNode("div", _hoisted_163, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "checkbox no-interaction mr-2",
                                          id: control._id,
                                          value: control._id,
                                          type: "checkbox",
                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.mappedControlsForDocument) = $event))
                                        }, null, 8, _hoisted_164), [
                                          [_vModelCheckbox, _ctx.mappedControlsForDocument]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_165, [
                                        _createElementVNode("label", {
                                          for: control._id
                                        }, _toDisplayString(control.controlTitle), 9, _hoisted_166)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : (_ctx.controlsDataArray.length != 0 && _ctx.presentDocumentData.statusCode != 10411)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlsDataArray, (control) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "flex my-2",
                                        key: control._id
                                      }, [
                                        _createElementVNode("div", _hoisted_168, [
                                          _createElementVNode("input", {
                                            class: "checkbox no-interaction mr-2",
                                            id: control._id,
                                            value: control._id,
                                            type: "checkbox",
                                            checked: ""
                                          }, null, 8, _hoisted_169)
                                        ]),
                                        _createElementVNode("div", _hoisted_170, [
                                          _createElementVNode("label", {
                                            for: control._id
                                          }, _toDisplayString(control.controlTitle), 9, _hoisted_171)
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_172, _cache[99] || (_cache[99] = [
                                    _createElementVNode("p", null, "No records found", -1)
                                  ])))
                        ]))
                      : (_ctx.authorRoleBased === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                            (_ctx.controlsDataArray.length != 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlsDataArray, (control) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "flex my-2",
                                      key: control._id
                                    }, [
                                      _createElementVNode("div", _hoisted_175, [
                                        _createElementVNode("input", {
                                          class: "checkbox no-interaction mr-2",
                                          id: control._id,
                                          value: control._id,
                                          type: "checkbox",
                                          checked: ""
                                        }, null, 8, _hoisted_176)
                                      ]),
                                      _createElementVNode("div", _hoisted_177, [
                                        _createElementVNode("label", {
                                          for: control._id
                                        }, _toDisplayString(control.controlTitle), 9, _hoisted_178)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_179, _cache[100] || (_cache[100] = [
                                  _createElementVNode("p", null, "No records found", -1)
                                ])))
                          ]))
                        : _createCommentVNode("", true),
                    (_ctx.authorRoleBased === true && _ctx.$route.params.type === 'myDocuments' && _ctx.presentDocumentData.statusCode === 10411 && _ctx.allControlsData.length != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                          _createElementVNode("button", {
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary mr-2", _ctx.disableContolsBtn ? 'btndisabled pointer-events-none' : 'btnprimary']),
                            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.cancelButtonForControls()))
                          }, " Cancel ", 10, _hoisted_181),
                          _createElementVNode("button", {
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass(["btnprimary ml-2", _ctx.disableContolsBtn ? 'btndisabled pointer-events-none' : 'btnprimary']),
                            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.mapControlsForDocument()))
                          }, " Save ", 10, _hoisted_182)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showDocumentInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                    _createElementVNode("div", _hoisted_184, [
                      _cache[101] || (_cache[101] = _createElementVNode("div", { class: "font-semibold" }, [
                        _createElementVNode("h5", null, "Properties")
                      ], -1)),
                      _createElementVNode("div", _hoisted_185, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "h-4 w-4 cursor-pointer",
                          onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.toggleDocumentInfo && _ctx.toggleDocumentInfo(...args)))
                        })
                      ])
                    ]),
                    (_ctx.$route.params.type == 'fileslist')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                              _cache[102] || (_cache[102] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Approved By", -1)),
                              _cache[103] || (_cache[103] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", _hoisted_187, _toDisplayString(_ctx.presentDocApprovedBy), 1)
                            ]),
                            _createElementVNode("div", _hoisted_188, [
                              _cache[104] || (_cache[104] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Status", -1)),
                              _cache[105] || (_cache[105] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", _hoisted_189, _toDisplayString(_ctx.statusValue.find((l) => {
                                                        return l.id == _ctx.documentDropdown.statusCode;
                                                    }).status), 1)
                            ]),
                            _createElementVNode("div", _hoisted_190, [
                              _cache[106] || (_cache[106] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Review Cycle/Time-Period", -1)),
                              _cache[107] || (_cache[107] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", _hoisted_191, _toDisplayString(_ctx.reviewPeriodSelect.find((l) => {
                                                        return l.id == _ctx.documentDropdown.reviewPeriod;
                                                    }).status), 1)
                            ]),
                            _createElementVNode("div", _hoisted_192, [
                              _cache[108] || (_cache[108] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Type", -1)),
                              _cache[109] || (_cache[109] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", _hoisted_193, _toDisplayString(_ctx.typeSelect.find((l) => {
                                                        return l.id == _ctx.documentDropdown.type;
                                                    }).status), 1)
                            ]),
                            _createElementVNode("div", _hoisted_194, [
                              _cache[110] || (_cache[110] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Classification", -1)),
                              _cache[111] || (_cache[111] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", _hoisted_195, _toDisplayString(_ctx.classificationSelect.find((l) => {
                                                        return l.id == _ctx.documentDropdown.classification;
                                                    }).status), 1)
                            ]),
                            _createElementVNode("div", _hoisted_196, [
                              _cache[112] || (_cache[112] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Version", -1)),
                              _cache[113] || (_cache[113] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", _hoisted_197, _toDisplayString(_ctx.documentDropdown.version), 1)
                            ]),
                            (_ctx.presentDocumentData.statusCode == 10411 && _ctx.$route.params.type == 'myDocuments' && _ctx.authorRoleBased === true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                  _createElementVNode("button", {
                                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.cancelDocumentProperties())),
                                    class: _normalizeClass(["mr-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'])
                                  }, "Cancel", 2),
                                  _createElementVNode("button", {
                                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.saveDocumentProperties())),
                                    class: _normalizeClass(["ml-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'])
                                  }, "Save", 2)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_ctx.$route.params.type=='archivedocuments')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_200, [
                                _cache[114] || (_cache[114] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Status", -1)),
                                _cache[115] || (_cache[115] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", _hoisted_201, _toDisplayString(_ctx.statusValue.find((l) => {
                                                        return l.id == _ctx.documentDropdown.statusCode;
                                                    }).status), 1)
                              ]),
                              _createElementVNode("div", _hoisted_202, [
                                _cache[116] || (_cache[116] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Review Cycle/Time-Period", -1)),
                                _cache[117] || (_cache[117] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", _hoisted_203, _toDisplayString(_ctx.reviewPeriodSelect.find((l) => {
                                                        return l.id == _ctx.documentDropdown.reviewPeriod;
                                                    }).status), 1)
                              ]),
                              _createElementVNode("div", _hoisted_204, [
                                _cache[118] || (_cache[118] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Type", -1)),
                                _cache[119] || (_cache[119] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", _hoisted_205, _toDisplayString(_ctx.typeSelect.find((l) => {
                                                        return l.id == _ctx.documentDropdown.type;
                                                    }).status), 1)
                              ]),
                              _createElementVNode("div", _hoisted_206, [
                                _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Classification", -1)),
                                _cache[121] || (_cache[121] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", _hoisted_207, _toDisplayString(_ctx.classificationSelect.find((l) => {
                                                        return l.id == _ctx.documentDropdown.classification;
                                                    }).status), 1)
                              ]),
                              _createElementVNode("div", _hoisted_208, [
                                _cache[122] || (_cache[122] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Version", -1)),
                                _createElementVNode("p", _hoisted_209, _toDisplayString(_ctx.documentDropdown.version), 1)
                              ]),
                              (_ctx.presentDocumentData.statusCode == 10411 && _ctx.$route.params.type == 'myDocuments' && _ctx.authorRoleBased === true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                    _createElementVNode("button", {
                                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.cancelDocumentProperties())),
                                      class: _normalizeClass(["mr-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'])
                                    }, "Cancel", 2),
                                    _createElementVNode("button", {
                                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.saveDocumentProperties())),
                                      class: _normalizeClass(["ml-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'])
                                    }, "Save", 2)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_211, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", null, [
                                _cache[123] || (_cache[123] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Status", -1)),
                                _createElementVNode("div", {
                                  class: _normalizeClass([_ctx.changeBackground(_ctx.documentDropdown.statusCode), "inputboxstyling1 mt-2"])
                                }, [
                                  _createElementVNode("div", _hoisted_212, _toDisplayString(_ctx.statusValue.find((obj)=>{
														return obj.id == _ctx.documentDropdown.statusCode
														}).status), 1)
                                ], 2)
                              ]),
                              _createElementVNode("div", _hoisted_213, [
                                _cache[124] || (_cache[124] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Review Cycle/Time-Period", -1)),
                                _createElementVNode("div", _hoisted_214, _toDisplayString(_ctx.reviewPeriodSelect.find((obj)=>{
														return obj.id == _ctx.documentDropdown.reviewPeriod
													}).status), 1)
                              ]),
                              _createElementVNode("div", _hoisted_215, [
                                _cache[125] || (_cache[125] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Type", -1)),
                                _createElementVNode("div", _hoisted_216, _toDisplayString(_ctx.typeSelect.find((obj)=>{
														return obj.id == _ctx.documentDropdown.type
													}).status), 1)
                              ]),
                              _createElementVNode("div", _hoisted_217, [
                                _cache[126] || (_cache[126] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Classification", -1)),
                                _createElementVNode("div", _hoisted_218, _toDisplayString(_ctx.classificationSelect.find((obj)=>{
														return obj.id == _ctx.documentDropdown.classification
													}).status), 1)
                              ]),
                              _createElementVNode("div", _hoisted_219, [
                                _cache[127] || (_cache[127] = _createElementVNode("label", { class: "controllabel text-xs font-semibold" }, "Version", -1)),
                                _createElementVNode("div", _hoisted_220, _toDisplayString(_ctx.documentDropdown.version), 1)
                              ])
                            ])
                          ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showComments)
                ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                    _createElementVNode("div", _hoisted_222, [
                      _createElementVNode("div", _hoisted_223, [
                        _cache[128] || (_cache[128] = _createElementVNode("div", { class: "font-semibold" }, [
                          _createElementVNode("h5", null, "Comments")
                        ], -1)),
                        _createElementVNode("div", _hoisted_224, [
                          _createElementVNode("img", {
                            src: _imports_0,
                            class: "h-4 w-4 cursor-pointer",
                            onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.toggleComments && _ctx.toggleComments(...args)))
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_225, [
                      _createElementVNode("div", _hoisted_226, [
                        _createElementVNode("div", _hoisted_227, [
                          _createElementVNode("ul", _hoisted_228, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedComments, (savedComment, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                class: "border border-gray-300 rounded-sm p-2 mb-2 relative pr-1 comment-item left-2.5 commentSectionWidth"
                              }, [
                                _createElementVNode("div", _hoisted_229, [
                                  _createElementVNode("div", _hoisted_230, [
                                    _createElementVNode("div", _hoisted_231, _toDisplayString(_ctx.getInitials(savedComment.createdBy)), 1),
                                    _createElementVNode("div", _hoisted_232, [
                                      _createElementVNode("div", _hoisted_233, _toDisplayString(_ctx.getUserName(savedComment.createdBy)), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_234, [
                                  _createElementVNode("div", _hoisted_235, _toDisplayString(_ctx.formatDate(savedComment.createdAt)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_236, [
                                  _createVNode(_component_safeHtml, {
                                    content: savedComment.comment
                                  }, null, 8, ["content"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_237, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_commentsEditor)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showWorkFlow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                    _createElementVNode("div", _hoisted_239, [
                      _cache[129] || (_cache[129] = _createElementVNode("div", { class: "font-semibold" }, [
                        _createElementVNode("h5", null, "Work Flow")
                      ], -1)),
                      _createElementVNode("div", _hoisted_240, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "h-4 w-4 cursor-pointer",
                          onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.toggleWorkFlow && _ctx.toggleWorkFlow(...args)))
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_241, [
                      _createElementVNode("div", _hoisted_242, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentFlow, (step, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass({ step: true, 'step-primary': _ctx.checkFlow(step.id, index) }),
                            "data-content": ""
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(step.details == null ? 'disablestep' : 'status_box')
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", step.details == null ? _ctx.workflow_color(1) : _ctx.workflow_color(step.id)])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass([step.details == null ? _ctx.workflow_text('noValue') : _ctx.workflow_text(step.id), "text-xs"])
                                  }, [
                                    _createElementVNode("b", null, _toDisplayString(_ctx.documentFlow.find((l) => {
																		return l.id == step.id;
																	}).name), 1)
                                  ], 2)
                                ], 2)
                              ]),
                              (step.details)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                    _createElementVNode("div", _hoisted_244, [
                                      _createElementVNode("div", _hoisted_245, [
                                        _createElementVNode("div", null, [
                                          (step.details.createdBy)
                                            ? (_openBlock(), _createElementBlock("b", _hoisted_246, _toDisplayString(_ctx.getUserName(step.details.createdBy)), 1))
                                            : (step.details.updatedBy)
                                              ? (_openBlock(), _createElementBlock("b", _hoisted_247, _toDisplayString(_ctx.getUserName(step.details.updatedBy)), 1))
                                              : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(_ctx.documentFlow.find((l) => {
																		return l.id == step.id;
																	}).statement), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", null, [
                                      (step.details.createdAt)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_248, _toDisplayString(_ctx.formatTime(step.details.createdAt)), 1))
                                        : (step.details.updatedAt)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_249, _toDisplayString(_ctx.formatTime(step.details.updatedAt)), 1))
                                          : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_250, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconsObj, (obj) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: obj,
                    onClick: ($event: any) => (_ctx.clickOnIcon(obj.id))
                  }, [
                    (obj.id == 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "container relative inline-block hover:bg-lightgrey",
                          style: _normalizeStyle({ 'background-color': _ctx.isHoveredInfo || _ctx.showDocumentInfo ? '#e9e9e9' : '' }),
                          onMouseenter: _cache[40] || (_cache[40] = ($event: any) => (_ctx.rightSidebar.properties = true)),
                          onMouseleave: _cache[41] || (_cache[41] = ($event: any) => (_ctx.rightSidebar.properties = false))
                        }, [
                          _createElementVNode("div", _hoisted_252, [
                            _cache[131] || (_cache[131] = _createElementVNode("img", {
                              src: _imports_6,
                              class: "h-5"
                            }, null, -1)),
                            (_ctx.rightSidebar.properties)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_253, _cache[130] || (_cache[130] = [
                                  _createElementVNode("div", { class: "px-2 text-white bg-primary" }, "Properties", -1)
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ], 36))
                      : ((obj.id == 2 && _ctx.$route.params.type == 'myDocuments') || (obj.id == 2 && _ctx.$route.params.type == 'approvals'))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "container relative inline-block hover:bg-lightgrey",
                            style: _normalizeStyle({ 'background-color': _ctx.isHoveredComments || _ctx.showComments ? '#e9e9e9' : '' }),
                            onMouseenter: _cache[42] || (_cache[42] = ($event: any) => (_ctx.rightSidebar.comments = true)),
                            onMouseleave: _cache[43] || (_cache[43] = ($event: any) => (_ctx.rightSidebar.comments = false))
                          }, [
                            _createElementVNode("div", _hoisted_254, [
                              _cache[133] || (_cache[133] = _createElementVNode("img", {
                                src: _imports_7,
                                class: "h-5"
                              }, null, -1)),
                              (_ctx.rightSidebar.comments)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_255, _cache[132] || (_cache[132] = [
                                    _createElementVNode("div", { class: "px-2 text-white bg-primary" }, "Comments", -1)
                                  ])))
                                : _createCommentVNode("", true)
                            ])
                          ], 36))
                        : ((obj.id == 3 && _ctx.$route.params.type == 'myDocuments') || (obj.id == 3 && _ctx.$route.params.type == 'approvals'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "container relative inline-block hover:bg-lightgrey",
                              style: _normalizeStyle({ 'background-color': _ctx.isHoveredFlow || _ctx.showWorkFlow ? '#e9e9e9' : '' }),
                              onMouseenter: _cache[44] || (_cache[44] = ($event: any) => (_ctx.rightSidebar.workFlow = true)),
                              onMouseleave: _cache[45] || (_cache[45] = ($event: any) => (_ctx.rightSidebar.workFlow = false))
                            }, [
                              _createElementVNode("div", _hoisted_256, [
                                _cache[135] || (_cache[135] = _createElementVNode("img", {
                                  src: _imports_8,
                                  class: "h-5"
                                }, null, -1)),
                                (_ctx.rightSidebar.workFlow)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_257, _cache[134] || (_cache[134] = [
                                      _createElementVNode("div", { class: "px-2 text-white bg-primary" }, "Work Flow", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                              ])
                            ], 36))
                          : _createCommentVNode("", true),
                    (obj.id == 4)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "container relative inline-block hover:bg-lightgrey",
                          style: _normalizeStyle({ 'background-color': _ctx.isHoveredControls || _ctx.showControls ? '#e9e9e9' : '' }),
                          onMouseenter: _cache[46] || (_cache[46] = ($event: any) => (_ctx.rightSidebar.controls = true)),
                          onMouseleave: _cache[47] || (_cache[47] = ($event: any) => (_ctx.rightSidebar.controls = false))
                        }, [
                          _createElementVNode("div", _hoisted_258, [
                            _cache[137] || (_cache[137] = _createElementVNode("img", {
                              src: _imports_9,
                              class: "h-5"
                            }, null, -1)),
                            (_ctx.rightSidebar.controls)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_259, _cache[136] || (_cache[136] = [
                                  _createElementVNode("div", { class: "px-2 text-white bg-primary" }, "Controls", -1)
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ], 36))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_251))
                }), 128))
              ])
            ])
          ], 2)
        ])
      ])
    ]),
    (_ctx.showPopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.showPopUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_260, [
              _createElementVNode("h1", {
                class: _normalizeClass(["pl-2 w-72", _ctx.titleLength > 40? 'table-ellipsis':''])
              }, _toDisplayString(_ctx.newDocumentObj.documentName), 3),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.onCancelButtonAddPopUp('close')))
              }, _cache[138] || (_cache[138] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_261, [
                    _createElementVNode("div", _hoisted_262, [
                      _createElementVNode("div", _hoisted_263, [
                        _createElementVNode("div", null, [
                          _cache[139] || (_cache[139] = _createElementVNode("label", { class: "controllabel" }, "Document Name", -1)),
                          _createElementVNode("div", _hoisted_264, _toDisplayString(_ctx.newDocumentObj.documentName), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_265, [
                        _createElementVNode("div", _hoisted_266, [
                          _cache[140] || (_cache[140] = _createElementVNode("label", { class: "controllabel" }, "Document ID", -1)),
                          _createElementVNode("div", _hoisted_267, _toDisplayString(_ctx.newDocumentObj.documentId), 1)
                        ]),
                        _createElementVNode("div", _hoisted_268, [
                          _cache[141] || (_cache[141] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                          _createElementVNode("div", _hoisted_269, _toDisplayString(_ctx.newDocumentObj.documentOwner[0].label), 1),
                          _cache[142] || (_cache[142] = _createElementVNode("div", { class: "mt-2" }, null, -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_270, [
                      _createElementVNode("div", _hoisted_271, [
                        _createElementVNode("div", _hoisted_272, [
                          _cache[144] || (_cache[144] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': _ctx.v$.newDocumentObj.classification.$error
                                            }]),
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.newDocumentObj.classification) = $event)),
                            disabled: ""
                          }, [
                            _cache[143] || (_cache[143] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classificationData, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option.id,
                                value: option.id
                              }, _toDisplayString(option.value), 9, _hoisted_273))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.newDocumentObj.classification]
                          ]),
                          (_ctx.v$.newDocumentObj.classification.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_274, [
                                (_ctx.v$.newDocumentObj.classification.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_275, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_276, [
                          _cache[145] || (_cache[145] = _createElementVNode("label", { class: "controllabel" }, "Version", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': _ctx.v$.newDocumentObj.version.$error || _ctx.validateVersion
                                            }]),
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.newDocumentObj.version) = $event)),
                            placeholder: "Version",
                            onInput: _cache[51] || (_cache[51] = ($event: any) => (_ctx.checkVersion()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.newDocumentObj.version,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.newDocumentObj.version.$error || _ctx.validateVersion)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_277, [
                                (_ctx.v$.newDocumentObj.version.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_278, "Required"))
                                  : _createCommentVNode("", true),
                                (!_ctx.v$.newDocumentObj.version.required.$invalid && _ctx.validateVersion)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_279, "Version should not be the same"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_280, [
                        _createElementVNode("div", _hoisted_281, [
                          _cache[147] || (_cache[147] = _createElementVNode("label", { class: "controllabel" }, "Type", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': _ctx.v$.newDocumentObj.type.$error
                                            }]),
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.newDocumentObj.type) = $event)),
                            disabled: ""
                          }, [
                            _cache[146] || (_cache[146] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeSelect, (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: i.id,
                                key: i
                              }, _toDisplayString(i.status), 9, _hoisted_282))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.newDocumentObj.type]
                          ]),
                          (_ctx.v$.newDocumentObj.type.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
                                (_ctx.v$.newDocumentObj.type.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_284, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_285, [
                          _cache[149] || (_cache[149] = _createElementVNode("label", { class: "controllabel" }, "Folder", -1)),
                          _createElementVNode("div", _hoisted_286, [
                            _createVNode(_component_Multiselect, {
                              modelValue: _ctx.newDocumentObj.folder,
                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.newDocumentObj.folder) = $event)),
                              options: _ctx.searchFoldersList,
                              onSearchChange: _ctx.asyncFind,
                              multiple: false,
                              disabled: "",
                              searchable: true,
                              "hide-selected": true,
                              "open-direction": "bottom",
                              "close-on-select": true,
                              "show-labels": false,
                              placeholder: "Folder",
                              class: _normalizeClass(["custom-multiselect", {
												'is-invalidmultiselect': _ctx.v$.newDocumentObj.folder.$error,
												'has-options': _ctx.searchFoldersList && _ctx.searchFoldersList.length > 0,
												'no-options':  !_ctx.searchFoldersList.length
											}])
                            }, {
                              noResult: _withCtx(() => _cache[148] || (_cache[148] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "options", "onSearchChange", "class"])
                          ]),
                          (_ctx.v$.newDocumentObj.folder.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_287, [
                                (_ctx.v$.newDocumentObj.folder.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_288, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_289, [
                        _createElementVNode("div", _hoisted_290, [
                          _cache[151] || (_cache[151] = _createElementVNode("label", { class: "controllabel" }, "Review Period", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': _ctx.v$.newDocumentObj.reviewPeriod.$error
                                            }]),
                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.newDocumentObj.reviewPeriod) = $event)),
                            disabled: ""
                          }, [
                            _cache[150] || (_cache[150] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewPeriodSelect, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option.id,
                                value: option.id
                              }, _toDisplayString(option.status), 9, _hoisted_291))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.newDocumentObj.reviewPeriod]
                          ]),
                          (_ctx.v$.newDocumentObj.reviewPeriod.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                                (_ctx.v$.newDocumentObj.reviewPeriod.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_293, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_294, [
                          _cache[153] || (_cache[153] = _createElementVNode("label", { class: "controllabel" }, "Author", -1)),
                          _createElementVNode("div", _hoisted_295, [
                            _createVNode(_component_Multiselect, {
                              modelValue: _ctx.newDocumentObj.author,
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.newDocumentObj.author) = $event)),
                              options: _ctx.allUserArray,
                              multiple: false,
                              caret: false,
                              "close-on-select": true,
                              "clear-on-select": true,
                              disabled: "",
                              label: "label",
                              "track-by": "value",
                              searchable: true,
                              hideArrow: true,
                              placeholder: "Author",
                              deselectLabel: "",
                              selectLabel: "",
                              class: _normalizeClass(["custom-multiselect", {
												'has-options': _ctx.allUserArray && _ctx.allUserArray.length > 0,
												'no-options':  !_ctx.allUserArray.length
											}])
                            }, {
                              noResult: _withCtx(() => _cache[152] || (_cache[152] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "options", "class"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_296, [
                          _cache[155] || (_cache[155] = _createElementVNode("label", { class: "controllabel" }, "Upload File", -1)),
                          _createElementVNode("div", _hoisted_297, [
                            _createElementVNode("input", {
                              type: "file",
                              accept: "application/pdf, .docx, .doc",
                              ref: "fileInput",
                              class: "hidden",
                              id: "upload",
                              onChange: _cache[56] || (_cache[56] = _withModifiers(($event: any) => (_ctx.updateFileName($event)), ["stop"]))
                            }, null, 544),
                            _cache[154] || (_cache[154] = _createElementVNode("label", {
                              for: "upload",
                              class: "float-right text-white btnprimary p-2 h-1"
                            }, "Browse File", -1)),
                            (!_ctx.newDocumentObj._id && !_ctx.newDocumentObj.file)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_298, _toDisplayString(_ctx.newDocumentObj.file ? _ctx.newDocumentObj.file.name : _ctx.placeholder), 1))
                              : (!_ctx.newDocumentObj.file || !_ctx.newDocumentObj.file.name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_299, _toDisplayString(_ctx.newDocumentObj.file ? _ctx.newDocumentObj.file : _ctx.placeholder), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_300, _toDisplayString(_ctx.newDocumentObj.file ? _ctx.newDocumentObj.file.name : _ctx.placeholder), 1))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_301, [
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.newDocumentObj) !== JSON.stringify(_ctx.dummyReviewJson) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.onCancelButtonAddPopUpInEditor()))
                  }, "Cancel", 10, _hoisted_302),
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    class: _normalizeClass(JSON.stringify(_ctx.newDocumentObj) !== JSON.stringify(_ctx.dummyReviewJson) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                    onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.updateReviewData(_ctx.newDocumentObj)))
                  }, "Update", 10, _hoisted_303)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}